import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

type SubscriptionStatus = 'ACTIVE' | 'SUSPENDED' | 'CANCELLED' | 'EXPIRED';

interface SubscriptionStatusBadgeProps {
  status: SubscriptionStatus | string;
  className?: string;
}

export function SubscriptionStatusBadge({ status, className }: SubscriptionStatusBadgeProps) {
  const { t } = useTranslation();
  
  const statusMap: Record<string, { labelKey: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' }> = {
    ACTIVE: { labelKey: 'billing.status.active', variant: 'default' },
    SUSPENDED: { labelKey: 'billing.status.suspended', variant: 'secondary' },
    CANCELLED: { labelKey: 'billing.status.cancelled', variant: 'outline' },
    EXPIRED: { labelKey: 'billing.status.expired', variant: 'destructive' },
  };

  const statusInfo = statusMap[status.toUpperCase()] || { labelKey: '', variant: 'outline' as const };
  const label = statusInfo.labelKey ? t(statusInfo.labelKey) : status;

  return (
    <Badge variant={statusInfo.variant} className={cn(className)}>
      {label}
    </Badge>
  );
}

